import React from 'react';
import Cricket from "../Statics/cricket.png";
const Navbar = () => {
    return (  
        <nav class="navbar navbar-light bg-dark " style={{margin:"10px"}}  >
        <a class="navbar-brand text-white" style={{paddingLeft:"500px"}} href="#">
          <img src={Cricket} width="30" height="30" class="d-inline-block align-top" alt=""/>
          CRICKET PREMIER LEAGUE
          <img src={Cricket} width="30" height="30" class="d-inline-block align-top" alt=""/>
        </a>
      </nav>
          );
}
 
export default Navbar;